import './index.scss';
import React, { useState } from 'react';
import PermissionChecker from '~/components/permission_checker';
import SidebarSection from '~/components/sidebar_section';
import Permissions from '~/settings/permissions';
import { useContentLibrary } from '../../providers/content_library_provider';
import EditMetadataModal from './edit_metadata_modal';
const MetadataPanel = () => {
    const { activeDocument } = useContentLibrary();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => setIsModalVisible(true);
    const hideModal = () => setIsModalVisible(false);
    const metadataFieldOrder = [
        'Form Title',
        'Form Number',
        'Form Edition Date',
        'Form Type',
        'Company Form Number',
        'Form Source',
        'Lines Of Business',
        'Product Groups',
        'Form Status',
        'Jurisdiction',
    ];
    const arrangeMetadataValues = (value) => {
        if (typeof value === 'boolean')
            return value ? 'True' : 'False';
        if (!Array.isArray(value))
            return value;
        return value.map(v => React.createElement(React.Fragment, { key: `metadata-${v}` },
            v,
            React.createElement("br", null)));
    };
    const sortMetadataFields = (metadataFields) => {
        metadataFields.sort((a, b) => {
            if (metadataFieldOrder.includes(a.name) && metadataFieldOrder.includes(b.name)) {
                return metadataFieldOrder.indexOf(a.name) < metadataFieldOrder.indexOf(b.name)
                    ? -1
                    : 1;
            }
            return metadataFieldOrder.includes(b.name) ? 1 : -1;
        });
    };
    let metadataFields = [];
    if (activeDocument) {
        metadataFields = activeDocument.source.metadataFields;
        sortMetadataFields(metadataFields);
    }
    return (React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.VIEW_FILE_METADATA] },
        React.createElement(SidebarSection, { title: 'Document Metadata', className: 'metadata-panel-container', isActive: !!activeDocument },
            activeDocument &&
                React.createElement(React.Fragment, null,
                    React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.EDIT_FILE_METADATA] },
                        React.createElement("div", { className: 'edit-button', title: 'Edit Metadata', onClick: showModal },
                            React.createElement("i", { className: 'fa fa-pencil-alt' }))),
                    metadataFields.map(metadataField => {
                        return React.createElement("div", { className: 'line-item', key: metadataField.name },
                            React.createElement("h6", { className: 'document-metadata' }, metadataField.name),
                            React.createElement("div", null, arrangeMetadataValues(metadataField.value)));
                    })),
            !activeDocument &&
                React.createElement("div", { className: 'sidebar-section-empty' },
                    React.createElement("span", null,
                        React.createElement("i", { className: 'fas fa-mouse-pointer' })),
                    React.createElement("div", null, "Click on a row to view the document's metadata."))),
        React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.EDIT_FILE_METADATA] }, activeDocument && React.createElement(EditMetadataModal, { isModalVisible: isModalVisible, hideModal: hideModal, activeDocument: activeDocument }))));
};
export default MetadataPanel;
